import React, { useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Building2, ChevronDown, Home, LogOut, Menu, Megaphone, ScrollText, Settings, Shield, Users, X } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { EstateProvider, useEstate } from "../contexts/EstateContext";
import { getRoleDisplayName, isPlatformSuperAdmin } from "../utils/permissions";

const initials = (name = "Admin") => name.split(/\s+/).map((part) => part[0]).join("").slice(0, 2).toUpperCase();

const Shell = () => {
  const { admin, user, logout } = useAuth();
  const currentUser = admin || user;
  const { estates, selectedEstateId, setSelectedEstateId, isLoading } = useEstate();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const navigation = [
    { label: "Overview", href: "/", icon: Home },
    { label: "Residents", href: "/residents", icon: Users },
    { label: "Units", href: "/units", icon: Building2 },
    { label: "Access logs", href: "/access-logs", icon: ScrollText },
    { label: "Security staff", href: "/security", icon: Shield },
    { label: "Broadcasts", href: "/broadcasts", icon: Megaphone },
    { label: "Settings", href: "/settings", icon: Settings },
  ];
  if (isPlatformSuperAdmin(currentUser)) navigation.splice(1, 0, { label: "Estates", href: "/estates", icon: Building2 });

  const signOut = () => { logout(); navigate("/login"); };
  return (
    <div className="admin-shell">
      <button className="mobile-nav-toggle" aria-label="Open navigation" onClick={() => setOpen(true)}><Menu /></button>
      {open && <button className="sidebar-scrim" aria-label="Close navigation" onClick={() => setOpen(false)} />}
      <aside className={`admin-sidebar ${open ? "is-open" : ""}`}>
        <div className="brand-lockup"><div className="brand-mark">E</div><div><strong>Estate Manage</strong><span>Admin console</span></div><button className="sidebar-close" aria-label="Close navigation" onClick={() => setOpen(false)}><X /></button></div>
        <label className="estate-switcher-label" htmlFor="estate-switcher">Estate</label>
        <div className="estate-switcher-wrap">
          <select id="estate-switcher" value={selectedEstateId} onChange={(event) => setSelectedEstateId(event.target.value)} disabled={isLoading || !estates.length}>
            {!estates.length && <option value="">No estate assigned</option>}
            {estates.map((estate) => <option key={estate._id || estate.id} value={estate._id || estate.id}>{estate.name}</option>)}
          </select><ChevronDown aria-hidden="true" />
        </div>
        <nav className="admin-nav" aria-label="Admin navigation">
          {navigation.map(({ label, href, icon: Icon }) => {
            const active = href === "/" ? location.pathname === "/" : location.pathname.startsWith(href);
            return <Link key={href} to={href} className={active ? "active" : ""} onClick={() => setOpen(false)}><Icon aria-hidden="true" /><span>{label}</span></Link>;
          })}
        </nav>
        <div className="admin-profile-card">
          <div className="profile-avatar">{initials(currentUser?.name || currentUser?.username)}</div>
          <div className="profile-copy"><strong>{currentUser?.name || currentUser?.username || "Admin"}</strong><span>{getRoleDisplayName(currentUser)}</span></div>
          <button aria-label="Log out" onClick={signOut}><LogOut /></button>
        </div>
      </aside>
      <main className="admin-main"><Outlet /></main>
    </div>
  );
};

const Layout = () => <EstateProvider><Shell /></EstateProvider>;
export default Layout;
